import Box from '@/common/components/Box'
import GeneralPoliticsSection from './components/GeneralPoliticsSection';
import UserAccessSection from './components/UserAccessSection';
import FinancialSection from './components/FinancialSection';
import TefInputModeSection from './components/TefInputModeSection';
import { useParams } from 'react-router-dom';
import useCompany from '@/common/hooks/queries/useCompany';
import SupplySection from './components/SupplySection';
import NotificationsSection from './components/NotificationsSection';
import ViewingPoliticsSection from './components/ViewingPoliticsSection';
import UsageDeclarationModeSection from './components/UsageDeclarationModeSection';
import BillDynamicGroupables from '@/features/privateCompanies/components/BillDynamicGroupables';
import LoadingSpinner from '@/common/components/LoadingSpinner';

const CompanyPoliticsShow = () => {
  const { id } = useParams()

  const { data: company, isFetching: isFetchingCompany } = useCompany({ id: id || '' })

  return (
    <Box className='flex flex-col relative gap-6 overflow-y-auto h-[calc(100vh-192px)]'>
      <div className='flex flex-col gap-4'>
        <LoadingSpinner isLoading={isFetchingCompany} className='absolute top-4 self-center' />

        <p className='text-xl font-bold'>
          Políticas Gerais
        </p>
        <UserAccessSection company={company} />
        <GeneralPoliticsSection company={company} />
        <BillDynamicGroupables />
      </div>

      <div className='flex flex-col gap-4'>
        <p className='text-xl font-bold'>
          Políticas de notificações
        </p>

        <NotificationsSection company={company} />
      </div>

      <div className='flex flex-col gap-4'>
        <p className='text-xl font-bold'>
          Políticas  CA
        </p>

        <FinancialSection company={company} />
        <TefInputModeSection company={company} />
        <SupplySection company={company} />
        <UsageDeclarationModeSection company={company} />
        <ViewingPoliticsSection company={company} />
      </div>
    </Box>
  )
}

export default CompanyPoliticsShow;
